import { render, staticRenderFns } from "./CustomFieldModalUpdateView.vue?vue&type=template&id=0b4dd2ec&scoped=true"
import script from "./CustomFieldModalUpdateView.vue?vue&type=script&lang=ts"
export * from "./CustomFieldModalUpdateView.vue?vue&type=script&lang=ts"
import style0 from "./CustomFieldModalUpdateView.vue?vue&type=style&index=0&id=0b4dd2ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4dd2ec",
  null
  
)

export default component.exports